import en from '@/locales/en.json'
import vi from '@/locales/vi.json'
import zh from '@/locales/zh.json'
import ko from '@/locales/ko.json'
import ru from '@/locales/ru.json'
import type { LanguageCode } from '~/data/language'

const dictionaries: Record<string, any> = {
  en,
  vi,
  zh,
  ko,
  ru,
}

export function getTranslation(locale: LanguageCode) {
  const dict = dictionaries[locale] || dictionaries.en
  return function t(path: string): string {
    return path.split('.').reduce((obj, key) => obj?.[key], dict) || ''
  }
}
export function getDictionary(locale: string) {
  return dictionaries[locale] || dictionaries.en
}
